import { WebStorageStateStore } from 'oidc-client-ts'

const url = window.__env__.ONE_URL
const OneAccount = {
  authority: url,
  client_id: window.__env__.ONE_CLIENT_ID,
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
  automaticSilentRenew: false,
  scope: 'openid email',
  metadata: {
    authorization_endpoint: `${url}/as/authorization.oauth2`,
    token_endpoint: `${window.__env__.REACT_APP_API_MIDDLEWARE_URL}/api/auth/token`,
    end_session_endpoint: `${url}/oidc/2/logout`,
  },
}
export default OneAccount
